module.exports = __webpack_public_path__ + "static/media/confetti_small.17b63544.jpg";